export default "__VITE_ASSET__Bqejupb0PakF$3XvnZwb5g__"